import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbImage from "../ui-kit/dfb_image"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbRte from "../ui-kit/dfb_rte"
import { Transformation } from "cloudinary-react"
import Section from "./section"

const MCardGridSwitchPerson = (props) => {
  return (
    <Section
      baseClass="m-CardGrid"
      defaultPaddingTop="medium"
      data={props.data}
    >
      <div className="m-CardGrid-wrapper">
        <div className="m-CardGrid-container">
          <div className="c-Headline m-CardGrid-headline">
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h3"
              add_class="c-Headline-strokeLine"
            />
          </div>
          <DfbParagraph
            text={props.data.text}
            tagName="div"
            add_class="m-CardGrid-paragraph"
          />
        </div>
        <div className="c-CardGrid">
          <div className="c-CardGrid-container">
            {props.data.switch_item.map((item, index) => (
              <div className="c-CardGrid-card c-CardGrid-cardFour" key={index}>
                <div className="c-CardSwitch c-CardSwitch--person">
                  {item.image && (
                    <div className="c-CardSwitch-imageContainer">
                      <DfbImage
                        image={item.image}
                        aspect_ratio="3:4"
                        overlay="75"
                        add_class="c-CardSwitch-image"
                      >
                        <Transformation
                          crop="fill"
                          gravity="faces:center"
                          width="300"
                          height="400"
                          quality="auto"
                          fetchFormat="auto"
                        />
                      </DfbImage>
                    </div>
                  )}
                  <DfbHeadline
                    headline={item.headline}
                    headline_level="h3"
                    add_class="c-CardSwitch-headline"
                  />
                  <div className="c-CardSwitch-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
                      />
                      <path
                        className="horizontally"
                        fill="currentColor"
                        d="M6 11h12v2H6z"
                      />
                      <path
                        className="vertically"
                        fill="currentColor"
                        d="M13 6v12h-2V6z"
                      />
                    </svg>
                  </div>
                  <div className="c-CardSwitch-overlay">
                    <DfbRte
                      text={item.richtext || item.plaintext}
                      add_class="c-CardSwitch-paragraph"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardGridSwitchPerson
